import OrderRequests from '../table/configs/orderRequests.json';
import accessoryRequestsConfig from '../table/configs/accessoryRequests.json';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {Component, OnInit} from '@angular/core';
import {TableConfig} from '../table/table-config';

@Component({
  templateUrl: './request-order.component.html'
})
export class RequestOrderComponent implements OnInit {
  selectedTabIndex: number;
  public user: any;
  public purchaseOrdersConfig: TableConfig;
  public accessoryRequestsConfig: TableConfig;

  constructor(private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.purchaseOrdersConfig = OrderRequests;
    this.accessoryRequestsConfig = accessoryRequestsConfig;
    this.selectedTabIndex = 0;
  }

  public async ngOnInit(): Promise<void> {
    this.user = await this.authService.getUser();
    this.activatedRoute.queryParams.subscribe(params => {
      const tab = params['tab'];
      this.selectedTabIndex = this.getTabIndexFromParam(tab);
    });
  }

  public changeTab(index: number): void {
    const tabParam = this.getTabParamFromIndex(index);
    this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: {tab: tabParam}, queryParamsHandling: 'merge'});
  }

  private getTabIndexFromParam(tab: string): number {
    switch (tab) {
      case 'accessories':
        return 1;
      default:
        return 0;
    }
  }

  private getTabParamFromIndex(index: number): string {
    switch (index) {
      case 1:
        return 'accessories';
      default:
        return null;
    }
  }


}
